export const MIN_POINTS_PAYOUT_AMOUNT = 50000
export const usdRatio = 0.001

export const payoutCurrencyRatioMap = {
	USD: usdRatio,
}
